import axios from '../../axios'

// 新增省份批次线信息
export const addProvinceBatchLine = (data) => {
    return axios({
        url: '/api/data/wish/batch/line',
        method: 'POST',
        data
    })
}

// 获取省份批次线详情
export const getProvinceBatchLineInfo = (data) => {
    return axios({
        url: '/api/data/wish/batch/line/info',
        method: 'GET',
        data
    })
}

// 修改省份批次线信息
export const editProvinceBatchLine = (data) => {
    return axios({
        url: '/api/data/wish/batch/line',
        method: 'PUT',
        data
    })
}

// 删除省份批次线信息
export const deleteProvinceBatchLine = (data) => {
    return axios({
        url: '/api/data/wish/batch/line',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索省份批次线信息列表
export const searchProvinceBatchLineList = (data) => {
    return axios({
        url: '/api/data/wish/batch/line',
        method: 'GET',
        data
    })
}

// 导入省份批次线
export const importProvinceBatchLine = (data) => {
    return axios({
        url: '/api/data/wish/batch/line/import',
        method: 'POST',
        data
    })
}

// 导出省份批次线
export const exportProvinceBatchLine = (data) => {
    return axios({
        url: '/api/data/wish/batch/line/export',
        method: 'POST',
        data
    })
}

// 批量更新省份批次线
export const updateProvinceBatchLine = (data) => {
    return axios({
        url: '/api/data/wish/batch/line/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除省份批次线
export const queryDelProvinceBatchLine = (data) => {
    return axios({
        url: '/api/data/wish/batch/line/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/provincebatchline.js